export default "__VITE_ASSET__D6opcUhj__"